import type { Security } from '../Security';
import { SubProductTypeEnum } from '../types';
import type {
  OTCFixedRateLoanProductTemplate,
  OTCFixedRateLoanSecurity,
  OTCFloatingRateLoanProductTemplate,
  OTCFloatingRateLoanSecurity,
  OTCForwardProductTemplate,
  OTCForwardSecurity,
  OTCOptionProductTemplate,
  OTCOptionSecurity,
  OTCRepoProductTemplate,
  OTCRepoSecurity,
} from './otcSecurityServerTypes';

// ---------------------------------------------------------------------------
// Type guards
// ---------------------------------------------------------------------------

// When Deals are created, related securities are created in SecMaster with a ProductDetails object.

export const isOTCForwardSecurity = (security: Security | undefined): security is OTCForwardSecurity => {
  return security?.SubProductType === SubProductTypeEnum.OTCForward && !!security.ProductDetails;
};
export const isFixedRateLoanSecurity = (security: Security | undefined): security is OTCFixedRateLoanSecurity => {
  return security?.SubProductType === SubProductTypeEnum.OTCFixedRateLoan && !!security.ProductDetails;
};
export const isFloatingRateLoanSecurity = (security: Security | undefined): security is OTCFloatingRateLoanSecurity => {
  return security?.SubProductType === SubProductTypeEnum.OTCFloatingRateLoan && !!security.ProductDetails;
};
export const isOTCOptionSecurity = (security: Security | undefined): security is OTCOptionSecurity => {
  return security?.SubProductType === SubProductTypeEnum.OTCVanillaOption && !!security.ProductDetails;
};

export const isOTCForwardProductTemplate = (security: Security | undefined): security is OTCForwardProductTemplate => {
  return isOTCForwardSecurity(security) && !security.ProductDetails.ExpiryTime;
};
export const isFixedRateLoanProductTemplate = (
  security: Security | undefined
): security is OTCFixedRateLoanProductTemplate => {
  return isFixedRateLoanSecurity(security) && !security.ProductDetails.ExpiryTime;
};
export const isFloatingRateLoanProductTemplate = (
  security: Security | undefined
): security is OTCFloatingRateLoanProductTemplate => {
  return isFloatingRateLoanSecurity(security) && !security.ProductDetails.ExpiryTime;
};
export const isOTCOptionProductTemplate = (security: Security | undefined): security is OTCOptionProductTemplate => {
  return isOTCOptionSecurity(security) && !security.ProductDetails.ExpiryTime;
};
export const isOTCRepoSecurity = (security: Security | undefined): security is OTCRepoSecurity => {
  return security?.SubProductType === SubProductTypeEnum.OTCRepo && !!security.ProductDetails;
};
export const isOTCRepoProductTemplate = (security: Security | undefined): security is OTCRepoProductTemplate => {
  return isOTCRepoSecurity(security) && !security.ProductDetails.ExpiryTime;
};
